// Any board can be looked at the way a kiosk display shows it, without being locked to it: the board's address with this added
// (a kiosk-restricted account always gets that view, and cannot leave it).
export const KIOSK_VIEW = 'view=kiosk';

export const wantsKioskView = (search: string) => new URLSearchParams(search).get('view') === 'kiosk';
